import subscriptions from 'src/js/modules/subscriptions';

const filterAvailableTemplates = (templates, availableSubscriptionTypes, isUserAuthenticated) => {
  const hasEcommerceSubscription = subscriptions.verifiers.hasEcommerceSubscription(
    availableSubscriptionTypes
  );

  if (isUserAuthenticated && !hasEcommerceSubscription) {
    return templates.filter((template) => !template.properties.hasOnlineStoreBlock);
  }

  return templates;
};

export default filterAvailableTemplates;
